module.exports = __webpack_public_path__ + "coming-soon.81f9e59.png";